/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon20Solid = forwardRef('CheckA2Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.6 6.246a1 1 0 0 0-1.415-1.414L5.41 12.607a.984.984 0 0 1-1.392 0l-2.285-2.284A1 1 0 1 0 .32 11.736l2.285 2.284a2.984 2.984 0 0 0 4.22 0L14.6 6.246Z" }),
        React.createElement("path", { d: "M19.664 6.246a1 1 0 0 0-1.414-1.414l-8.393 8.393a1 1 0 1 0 1.414 1.414l8.393-8.393Z" })));
});
